"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const FilledInput_1 = require("@mui/material/FilledInput");
const IconButton_1 = require("@mui/material/IconButton");
const OutlinedInput_1 = require("@mui/material/OutlinedInput");
const styles_1 = require("@mui/material/styles");
const PREFIX = "InputGroup";
exports.classes = {
    input: `${PREFIX}-input`,
    lockedxs: `${PREFIX}-lockedxs`,
    lockedsm: `${PREFIX}-lockedsm`,
    lockedmd: `${PREFIX}-lockedmd`,
    lockedlg: `${PREFIX}-lockedlg`,
    button: `${PREFIX}-button`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    [`&.${exports.classes.lockedxs}`]: { ...locked },
    [`&.${exports.classes.lockedsm}`]: { [theme.breakpoints.up("sm")]: { ...locked } },
    [`&.${exports.classes.lockedmd}`]: { [theme.breakpoints.up("md")]: { ...locked } },
    [`&.${exports.classes.lockedlg}`]: { [theme.breakpoints.up("lg")]: { ...locked } },
    [`.${exports.classes.input}`]: {
        marginBottom: "15px"
    }
}));
const locked = {
    flexDirection: "row",
    [`.${exports.classes.input}`]: {
        margin: 0,
        display: "flex",
        flex: 1,
        backgroundColor: "#fff",
        borderTopLeftRadius: "4px",
        borderBottomLeftRadius: "4px",
        [`.${OutlinedInput_1.outlinedInputClasses.notchedOutline}, .${FilledInput_1.filledInputClasses.root}`]: {
            borderTopLeftRadius: "4px",
            borderBottomLeftRadius: "4px",
            borderTopRightRadius: "0px",
            borderBottomRightRadius: "0px",
            borderRight: "none"
        }
    },
    [`.${exports.classes.button}`]: {
        borderTopLeftRadius: "0px",
        borderBottomLeftRadius: "0px",
        height: "auto",
        [`&.${IconButton_1.iconButtonClasses.root}`]: {
            width: "56px"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2lucHV0LWdyb3VwL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwyREFBK0Q7QUFDL0QseURBQTZEO0FBQzdELCtEQUFtRTtBQUNuRSxpREFBOEM7QUFFOUMsTUFBTSxNQUFNLEdBQUcsWUFBWSxDQUFDO0FBRWYsUUFBQSxPQUFPLEdBQUc7SUFDckIsS0FBSyxFQUFFLEdBQUcsTUFBTSxRQUFRO0lBQ3hCLFFBQVEsRUFBRSxHQUFHLE1BQU0sV0FBVztJQUM5QixRQUFRLEVBQUUsR0FBRyxNQUFNLFdBQVc7SUFDOUIsUUFBUSxFQUFFLEdBQUcsTUFBTSxXQUFXO0lBQzlCLFFBQVEsRUFBRSxHQUFHLE1BQU0sV0FBVztJQUM5QixNQUFNLEVBQUUsR0FBRyxNQUFNLFNBQVM7Q0FDM0IsQ0FBQztBQUVXLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNoRCxPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLENBQUMsS0FBSyxlQUFPLENBQUMsUUFBUSxFQUFFLENBQUMsRUFBRSxFQUFFLEdBQUcsTUFBTSxFQUFFO0lBQ3hDLENBQUMsS0FBSyxlQUFPLENBQUMsUUFBUSxFQUFFLENBQUMsRUFBRSxFQUFFLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRSxFQUFFLEdBQUcsTUFBTSxFQUFFLEVBQUU7SUFDMUUsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFLEVBQUUsR0FBRyxNQUFNLEVBQUUsRUFBRTtJQUMxRSxDQUFDLEtBQUssZUFBTyxDQUFDLFFBQVEsRUFBRSxDQUFDLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsRUFBRSxHQUFHLE1BQU0sRUFBRSxFQUFFO0lBQzFFLENBQUMsSUFBSSxlQUFPLENBQUMsS0FBSyxFQUFFLENBQUMsRUFBRTtRQUNyQixZQUFZLEVBQUUsTUFBTTtLQUNyQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRUosTUFBTSxNQUFNLEdBQUc7SUFDYixhQUFhLEVBQUUsS0FBSztJQUNwQixDQUFDLElBQUksZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDckIsTUFBTSxFQUFFLENBQUM7UUFDVCxPQUFPLEVBQUUsTUFBTTtRQUNmLElBQUksRUFBRSxDQUFDO1FBQ1AsZUFBZSxFQUFFLE1BQU07UUFDdkIsbUJBQW1CLEVBQUUsS0FBSztRQUMxQixzQkFBc0IsRUFBRSxLQUFLO1FBQzdCLENBQUMsSUFBSSxvQ0FBb0IsQ0FBQyxjQUFjLE1BQU0sZ0NBQWtCLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtZQUN4RSxtQkFBbUIsRUFBRSxLQUFLO1lBQzFCLHNCQUFzQixFQUFFLEtBQUs7WUFDN0Isb0JBQW9CLEVBQUUsS0FBSztZQUMzQix1QkFBdUIsRUFBRSxLQUFLO1lBQzlCLFdBQVcsRUFBRSxNQUFNO1NBQ3BCO0tBQ0Y7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUU7UUFDdEIsbUJBQW1CLEVBQUUsS0FBSztRQUMxQixzQkFBc0IsRUFBRSxLQUFLO1FBQzdCLE1BQU0sRUFBRSxNQUFNO1FBQ2QsQ0FBQyxLQUFLLDhCQUFpQixDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7WUFDL0IsS0FBSyxFQUFFLE1BQU07U0FDZDtLQUNGO0NBQ0YsQ0FBQyJ9